import { _ as _applyDecoratedDescriptor, a as _initializerDefineProperty } from '../_rollupPluginBabelHelpers-3b0ba74f.js';
import Model, { attr, belongsTo, hasMany } from '@ember-data/model';
import { tsCodeToClass, sdiCodeToIta, sdiCodeToClass, sdiCodeToIcon, codFiscaleValidMsg, normalizeCurrency } from 'beebee-base/lib/utility';
import { inject } from '@ember/service';
import { cached, tracked } from '@glimmer/tracking';
import { _saveAll, _safeReload, applyStyle, _sortedCustomFields } from '../lib/utility.js';

var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _dec8, _dec9, _dec0, _dec1, _dec10, _dec11, _dec12, _dec13, _dec14, _dec15, _dec16, _dec17, _dec18, _dec19, _dec20, _dec21, _dec22, _dec23, _dec24, _dec25, _dec26, _dec27, _dec28, _dec29, _dec30, _dec31, _dec32, _dec33, _dec34, _dec35, _dec36, _dec37, _dec38, _dec39, _dec40, _dec41, _dec42, _dec43, _dec44, _dec45, _dec46, _dec47, _dec48, _dec49, _dec50, _dec51, _dec52, _dec53, _dec54, _dec55, _dec56, _dec57, _dec58, _dec59, _dec60, _dec61, _dec62, _dec63, _dec64, _dec65, _dec66, _dec67, _dec68, _dec69, _dec70, _dec71, _dec72, _dec73, _dec74, _dec75, _dec76, _dec77, _dec78, _dec79, _dec80, _dec81, _dec82, _dec83, _dec84, _dec85, _dec86, _dec87, _dec88, _dec89, _dec90, _dec91, _dec92, _dec93, _dec94, _dec95, _dec96, _dec97, _dec98, _dec99, _dec100, _dec101, _dec102, _dec103, _dec104, _dec105, _dec106, _dec107, _dec108, _dec109, _dec110, _dec111, _dec112, _dec113, _dec114, _dec115, _dec116, _dec117, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor0, _descriptor1, _descriptor10, _descriptor11, _descriptor12, _descriptor13, _descriptor14, _descriptor15, _descriptor16, _descriptor17, _descriptor18, _descriptor19, _descriptor20, _descriptor21, _descriptor22, _descriptor23, _descriptor24, _descriptor25, _descriptor26, _descriptor27, _descriptor28, _descriptor29, _descriptor30, _descriptor31, _descriptor32, _descriptor33, _descriptor34, _descriptor35, _descriptor36, _descriptor37, _descriptor38, _descriptor39, _descriptor40, _descriptor41, _descriptor42, _descriptor43, _descriptor44, _descriptor45, _descriptor46, _descriptor47, _descriptor48, _descriptor49, _descriptor50, _descriptor51, _descriptor52, _descriptor53, _descriptor54, _descriptor55, _descriptor56, _descriptor57, _descriptor58, _descriptor59, _descriptor60, _descriptor61, _descriptor62, _descriptor63, _descriptor64, _descriptor65, _descriptor66, _descriptor67, _descriptor68, _descriptor69, _descriptor70, _descriptor71, _descriptor72, _descriptor73, _descriptor74, _descriptor75, _descriptor76, _descriptor77, _descriptor78, _descriptor79, _descriptor80, _descriptor81, _descriptor82, _descriptor83, _descriptor84, _descriptor85, _descriptor86, _descriptor87, _descriptor88, _descriptor89, _descriptor90, _descriptor91, _descriptor92, _descriptor93, _descriptor94, _descriptor95, _descriptor96, _descriptor97, _descriptor98, _descriptor99, _descriptor100, _descriptor101, _descriptor102, _descriptor103, _descriptor104, _descriptor105, _descriptor106, _descriptor107, _descriptor108, _descriptor109, _descriptor110, _descriptor111, _descriptor112, _descriptor113, _descriptor114, _descriptor115, _descriptor116, _descriptor117, _descriptor118, _descriptor119, _descriptor120;
let InvoiceModel = (_dec = attr('string'), _dec2 = attr('string'), _dec3 = attr('boolean'), _dec4 = attr('boolean'), _dec5 = attr('boolean'), _dec6 = attr('string'), _dec7 = attr('string'), _dec8 = attr('number'), _dec9 = attr('string'), _dec0 = attr('string'), _dec1 = attr('string'), _dec10 = attr('string'), _dec11 = attr('string'), _dec12 = attr('string'), _dec13 = attr('boolean', {
  allowNull: true
}), _dec14 = attr('string'), _dec15 = attr('string'), _dec16 = attr('string'), _dec17 = belongsTo('address', {
  inverse: null,
  async: false
}), _dec18 = attr('string'), _dec19 = attr('string'), _dec20 = attr('string'), _dec21 = attr('string'), _dec22 = attr('number', {
  currency: true
}), _dec23 = attr('number', {
  currency: true
}), _dec24 = attr('number', {
  currency: true
}), _dec25 = attr('number', {
  currency: true
}), _dec26 = attr('string'), _dec27 = attr('string'), _dec28 = attr('string'), _dec29 = attr('string'), _dec30 = attr('boolean'), _dec31 = attr('boolean'), _dec32 = attr('string'), _dec33 = attr('boolean'), _dec34 = attr('string'), _dec35 = attr('string'), _dec36 = attr('string'), _dec37 = attr('string'), _dec38 = attr('string'), _dec39 = attr('string'), _dec40 = attr('boolean'), _dec41 = attr('number', {
  currency: true
}), _dec42 = attr('number', {
  currency: true
}), _dec43 = attr('number', {
  currency: true
}), _dec44 = attr('boolean', {
  defaultValue: false
}), _dec45 = attr('boolean'), _dec46 = attr('boolean'), _dec47 = attr('boolean', {
  allowNull: true
}), _dec48 = attr('boolean'), _dec49 = attr('string'), _dec50 = attr('string'), _dec51 = attr('string'), _dec52 = attr('string'), _dec53 = attr('string'), _dec54 = attr('string'), _dec55 = hasMany('invoicegroup', {
  inverse: 'invoice',
  async: false
}), _dec56 = hasMany('invoiceproduct', {
  inverse: 'invoice',
  async: false
}), _dec57 = hasMany('invoicetax', {
  inverse: 'invoice',
  async: false
}), _dec58 = hasMany('invoicemailsend', {
  inverse: 'invoice',
  async: false
}), _dec59 = hasMany('file', {
  inverse: null,
  async: true
}), _dec60 = attr('boolean', {
  allowNull: true
}), _dec61 = attr('string'), _dec62 = belongsTo('address', {
  inverse: null,
  async: false
}), _dec63 = attr('string'), _dec64 = attr('string'), _dec65 = attr('string'), _dec66 = attr('string'), _dec67 = attr('boolean', {
  allowNull: true
}), _dec68 = hasMany('custom_field', {
  inverse: null,
  async: false
}), _dec69 = hasMany('contact', {
  inverse: null,
  async: false
}), _dec70 = hasMany('product', {
  inverse: null,
  async: false
}), _dec71 = hasMany('project', {
  inverse: null,
  async: false
}), _dec72 = hasMany('event', {
  inverse: null,
  async: false
}), _dec73 = hasMany('workhour', {
  inverse: null,
  async: false
}), _dec74 = hasMany('invoice', {
  inverse: null,
  async: false
}), _dec75 = hasMany('expense', {
  inverse: null,
  async: false
}), _dec76 = belongsTo('contact', {
  inverse: null,
  async: false
}), _dec77 = belongsTo('contact', {
  inverse: null,
  async: false
}), _dec78 = hasMany('payment', {
  inverse: null,
  async: false
}), _dec79 = hasMany('invoices-notifiche-sdi', {
  inverse: null,
  async: false
}), _dec80 = hasMany('expire_date', {
  inverse: null,
  async: false
}), _dec81 = belongsTo('invoice_style', {
  inverse: null,
  async: false
}), _dec82 = attr('string'), _dec83 = attr('string'), _dec84 = attr('string'), _dec85 = attr('string'), _dec86 = attr('string'), _dec87 = attr('number', {
  currency: true
}), _dec88 = attr('number', {
  currency: true
}), _dec89 = attr('number', {
  currency: true
}), _dec90 = attr('number', {
  currency: true
}), _dec91 = attr('string'), _dec92 = attr('string'), _dec93 = attr('string'), _dec94 = attr('string'), _dec95 = attr('boolean'), _dec96 = attr('boolean', {
  defaultValue: true
}), _dec97 = attr('boolean', {
  defaultValue: true
}), _dec98 = attr('string'), _dec99 = attr('string', {
  defaultValue: 'EUR'
}), _dec100 = attr('number'), _dec101 = attr('string'), _dec102 = attr('string'), _dec103 = attr('boolean'), _dec104 = attr('number', {
  defaultValue: 0
}), _dec105 = attr('number', {
  defaultValue: 0
}), _dec106 = attr('number', {
  defaultValue: 0
}), _dec107 = attr('number', {
  defaultValue: 0
}), _dec108 = attr('number', {
  defaultValue: 0
}), _dec109 = attr('number', {
  defaultValue: 0
}), _dec110 = attr('number', {
  defaultValue: 0
}), _dec111 = attr('number', {
  defaultValue: 0
}), _dec112 = attr('number', {
  defaultValue: 0
}), _dec113 = attr('number', {
  defaultValue: 0
}), _dec114 = attr('number', {
  defaultValue: 0
}), _dec115 = attr('number', {
  defaultValue: 0
}), _dec116 = hasMany('contact', {
  inverse: null,
  async: false
}), _dec117 = attr('boolean', {
  defaultValue: false
}), _class = class InvoiceModel extends Model {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "intl", _descriptor, this);
    _initializerDefineProperty(this, "session", _descriptor2, this);
    _initializerDefineProperty(this, "checked", _descriptor3, this);
    _initializerDefineProperty(this, "document_type", _descriptor4, this);
    _initializerDefineProperty(this, "xml_document_type", _descriptor5, this);
    _initializerDefineProperty(this, "estimate", _descriptor6, this);
    _initializerDefineProperty(this, "advanced", _descriptor7, this);
    _initializerDefineProperty(this, "archivied", _descriptor8, this);
    _initializerDefineProperty(this, "created_at", _descriptor9, this);
    _initializerDefineProperty(this, "number", _descriptor0, this);
    _initializerDefineProperty(this, "real_number", _descriptor1, this);
    _initializerDefineProperty(this, "prefix_number", _descriptor10, this);
    _initializerDefineProperty(this, "suffix_number", _descriptor11, this);
    _initializerDefineProperty(this, "date", _descriptor12, this);
    _initializerDefineProperty(this, "dati_invio_ts", _descriptor13, this);
    _initializerDefineProperty(this, "date_competence", _descriptor14, this);
    _initializerDefineProperty(this, "regime_fiscale", _descriptor15, this);
    _initializerDefineProperty(this, "fisica_giuridica", _descriptor16, this);
    _initializerDefineProperty(this, "society", _descriptor17, this);
    _initializerDefineProperty(this, "society_first_name", _descriptor18, this);
    _initializerDefineProperty(this, "society_last_name", _descriptor19, this);
    _initializerDefineProperty(this, "society_address", _descriptor20, this);
    _initializerDefineProperty(this, "society_piva_name", _descriptor21, this);
    _initializerDefineProperty(this, "society_piva", _descriptor22, this);
    _initializerDefineProperty(this, "society_cf", _descriptor23, this);
    _initializerDefineProperty(this, "rea", _descriptor24, this);
    _initializerDefineProperty(this, "imponibile", _descriptor25, this);
    _initializerDefineProperty(this, "total", _descriptor26, this);
    _initializerDefineProperty(this, "da_pagare", _descriptor27, this);
    _initializerDefineProperty(this, "pagato", _descriptor28, this);
    _initializerDefineProperty(this, "status", _descriptor29, this);
    _initializerDefineProperty(this, "status_sdi", _descriptor30, this);
    _initializerDefineProperty(this, "ts_codice", _descriptor31, this);
    _initializerDefineProperty(this, "ts_descrizione", _descriptor32, this);
    _initializerDefineProperty(this, "can_send_sdi", _descriptor33, this);
    _initializerDefineProperty(this, "lordo", _descriptor34, this);
    _initializerDefineProperty(this, "notes", _descriptor35, this);
    _initializerDefineProperty(this, "is_creditnote", _descriptor36, this);
    _initializerDefineProperty(this, "creditnote_invoicenumber", _descriptor37, this);
    _initializerDefineProperty(this, "creditnote_invoicedate", _descriptor38, this);
    _initializerDefineProperty(this, "thumbnail_url", _descriptor39, this);
    _initializerDefineProperty(this, "thumbnail_name", _descriptor40, this);
    _initializerDefineProperty(this, "thumbnail_etag", _descriptor41, this);
    _initializerDefineProperty(this, "thumbnail_type", _descriptor42, this);
    _initializerDefineProperty(this, "fixed_price_type", _descriptor43, this);
    _initializerDefineProperty(this, "fixed_price", _descriptor44, this);
    _initializerDefineProperty(this, "discount", _descriptor45, this);
    _initializerDefineProperty(this, "discount_rate", _descriptor46, this);
    _initializerDefineProperty(this, "discount_type", _descriptor47, this);
    _initializerDefineProperty(this, "bollo_cliente", _descriptor48, this);
    _initializerDefineProperty(this, "bollo_virtuale", _descriptor49, this);
    _initializerDefineProperty(this, "bollo", _descriptor50, this);
    _initializerDefineProperty(this, "rivalsa", _descriptor51, this);
    _initializerDefineProperty(this, "causale", _descriptor52, this);
    _initializerDefineProperty(this, "ditta", _descriptor53, this);
    _initializerDefineProperty(this, "mezzo", _descriptor54, this);
    _initializerDefineProperty(this, "data_consegna", _descriptor55, this);
    _initializerDefineProperty(this, "peso", _descriptor56, this);
    _initializerDefineProperty(this, "colli", _descriptor57, this);
    _initializerDefineProperty(this, "invoicegroups", _descriptor58, this);
    _initializerDefineProperty(this, "invoiceproducts", _descriptor59, this);
    _initializerDefineProperty(this, "invoicetaxes", _descriptor60, this);
    _initializerDefineProperty(this, "invoicemailsends", _descriptor61, this);
    _initializerDefineProperty(this, "files", _descriptor62, this);
    _initializerDefineProperty(this, "contact_fisica_giuridica", _descriptor63, this);
    _initializerDefineProperty(this, "contact_name", _descriptor64, this);
    _initializerDefineProperty(this, "contact_address", _descriptor65, this);
    _initializerDefineProperty(this, "contact_piva", _descriptor66, this);
    _initializerDefineProperty(this, "contact_cf", _descriptor67, this);
    _initializerDefineProperty(this, "contact_first_name", _descriptor68, this);
    _initializerDefineProperty(this, "contact_last_name", _descriptor69, this);
    _initializerDefineProperty(this, "contact_ente_pa", _descriptor70, this);
    _initializerDefineProperty(this, "custom_fields", _descriptor71, this);
    _initializerDefineProperty(this, "contacts", _descriptor72, this);
    _initializerDefineProperty(this, "products", _descriptor73, this);
    _initializerDefineProperty(this, "projects", _descriptor74, this);
    _initializerDefineProperty(this, "events", _descriptor75, this);
    _initializerDefineProperty(this, "workhours", _descriptor76, this);
    _initializerDefineProperty(this, "related_invoices", _descriptor77, this);
    _initializerDefineProperty(this, "expenses", _descriptor78, this);
    _initializerDefineProperty(this, "user", _descriptor79, this);
    _initializerDefineProperty(this, "contact", _descriptor80, this);
    _initializerDefineProperty(this, "payments", _descriptor81, this);
    _initializerDefineProperty(this, "invoices_notifiche_sdis", _descriptor82, this);
    _initializerDefineProperty(this, "expire_dates", _descriptor83, this);
    _initializerDefineProperty(this, "invoice_style", _descriptor84, this);
    _initializerDefineProperty(this, "pec_destinatario", _descriptor85, this);
    _initializerDefineProperty(this, "codice_destinatario", _descriptor86, this);
    _initializerDefineProperty(this, "pec_mittente", _descriptor87, this);
    _initializerDefineProperty(this, "assurance_id", _descriptor88, this);
    _initializerDefineProperty(this, "assurance_name", _descriptor89, this);
    _initializerDefineProperty(this, "quota_assistito", _descriptor90, this);
    _initializerDefineProperty(this, "quota_assicurazione", _descriptor91, this);
    _initializerDefineProperty(this, "pagato_assistito", _descriptor92, this);
    _initializerDefineProperty(this, "pagato_assicurazione", _descriptor93, this);
    _initializerDefineProperty(this, "bank_name", _descriptor94, this);
    _initializerDefineProperty(this, "bank_iban", _descriptor95, this);
    _initializerDefineProperty(this, "bank_bic", _descriptor96, this);
    _initializerDefineProperty(this, "sdi_field", _descriptor97, this);
    _initializerDefineProperty(this, "paid_all", _descriptor98, this);
    _initializerDefineProperty(this, "ts_send", _descriptor99, this);
    _initializerDefineProperty(this, "ts_enable", _descriptor100, this);
    _initializerDefineProperty(this, "esigibilita_iva", _descriptor101, this);
    _initializerDefineProperty(this, "valuta", _descriptor102, this);
    _initializerDefineProperty(this, "tasso_cambio", _descriptor103, this);
    _initializerDefineProperty(this, "data_option1", _descriptor104, this);
    _initializerDefineProperty(this, "data_option2", _descriptor105, this);
    _initializerDefineProperty(this, "boolean_option1", _descriptor106, this);
    _initializerDefineProperty(this, "total_files_number", _descriptor107, this);
    _initializerDefineProperty(this, "total_payments", _descriptor108, this);
    _initializerDefineProperty(this, "total_payments_number", _descriptor109, this);
    _initializerDefineProperty(this, "total_contacts_number", _descriptor110, this);
    _initializerDefineProperty(this, "total_products_number", _descriptor111, this);
    _initializerDefineProperty(this, "total_projects_number", _descriptor112, this);
    _initializerDefineProperty(this, "total_events_number", _descriptor113, this);
    _initializerDefineProperty(this, "total_invoices_number", _descriptor114, this);
    _initializerDefineProperty(this, "total_estimates_number", _descriptor115, this);
    _initializerDefineProperty(this, "total_ddts_number", _descriptor116, this);
    _initializerDefineProperty(this, "total_orders_number", _descriptor117, this);
    _initializerDefineProperty(this, "total_contracts_number", _descriptor118, this);
    _initializerDefineProperty(this, "current_users", _descriptor119, this);
    _initializerDefineProperty(this, "my_dirty", _descriptor120, this);
  }
  get idArray() {
    return [this.id];
  }
  saveAll(model) {
    return _saveAll(model, this.session, 'invoices_all');
  }
  safeReload() {
    return _safeReload(this);
  }
  get society_label() {
    const styleName = this.session.option_field?.model_custom_style?.contact;
    if (this.fisica_giuridica) {
      return applyStyle(this.society, styleName) || '';
    } else {
      const firstName = this.society_first_name ?? '';
      const lastName = this.society_last_name ?? '';
      const fullName = `${lastName} ${firstName}`.trim();
      return applyStyle(fullName, styleName);
    }
  }
  get cli_ts_class() {
    return tsCodeToClass(this.ts_codice);
  }
  get cli_ts_label_class() {
    return tsCodeToClass(this.ts_codice)?.replace('text-', '') || 'secondary';
  }
  get cli_sdi_stato_ita() {
    return sdiCodeToIta(this.status_sdi);
  }
  get cli_sdi_class() {
    return sdiCodeToClass(this.status_sdi);
  }
  get cli_sdi_icon() {
    return sdiCodeToIcon(this.status_sdi);
  }
  get cli_sdi_label_class() {
    return sdiCodeToClass(this.status_sdi)?.replace('text-', '') || 'secondary';
  }
  get contactCodFiscaleValidMsg() {
    return codFiscaleValidMsg(this.contact_cf, this.contact_fisica_giuridica, this.contact_name, this.contact_address?.location_address_country, this.contact_first_name, this.contact_last_name);
  }
  get contact_label() {
    const styleName = this.session.option_field?.model_custom_style?.contact;
    if (this.contact_fisica_giuridica || this.contact_ente_pa) {
      return applyStyle(this.contact_name, styleName) || '';
    } else {
      const firstName = this.contact_first_name ?? '';
      const lastName = this.contact_last_name ?? '';
      const fullName = `${lastName} ${firstName}`.trim();
      return applyStyle(fullName, styleName);
    }
  }
  get sorted_custom_fields() {
    let fields;
    try {
      fields = this.custom_fields;
    } catch {
      return [];
    }
    if (Array.isArray(fields)) {
      return _sortedCustomFields(fields, this.isDeleted);
    }
    if (fields && typeof fields.then === 'function') {
      return fields.then(resolvedFields => _sortedCustomFields(resolvedFields, this.isDeleted));
    }
    return [];
  }
  get show_fixed_price() {
    return this.document_type !== 'invoice' && this.fixed_price;
  }
  get label() {
    const timeZone = this.session?.me?.time_zone || 'Europe/Rome';
    const start_date = this.date ? this.intl.formatDate(this.date, {
      timeZone
    }) : '';
    return this.date ? `#${this.number ?? ''} ${start_date}` : this.document_type;
  }
  get sub_label() {
    const number = this.total || 0;
    const currency = this.valuta || this.session?.option_field?.intl?.currency || 'EUR';
    const tot_currency = this.intl.formatNumber(number, {
      style: 'currency',
      currency: normalizeCurrency(currency)
    });
    const documentTypeStatus = `${this.document_type}s ${this.status}`;
    const contactLabel = this.contact_label || '';
    return `${tot_currency} ${this.intl.t(documentTypeStatus)} ${contactLabel}`;
  }
  get payment_due() {
    const paymentDifference = parseFloat(this.show_fixed_price ? this.fixed_price - this.total_payments : this.total - this.total_payments);
    return isNaN(paymentDifference) ? '0.00' : paymentDifference.toFixed(2);
  }
  get current_users_label() {
    return (this.current_users ?? []).map(user => user.label).join(' ');
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "intl", [inject], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "session", [inject], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "checked", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "document_type", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "xml_document_type", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "estimate", [_dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "advanced", [_dec4], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "archivied", [_dec5], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "created_at", [_dec6], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor0 = _applyDecoratedDescriptor(_class.prototype, "number", [_dec7], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor1 = _applyDecoratedDescriptor(_class.prototype, "real_number", [_dec8], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor10 = _applyDecoratedDescriptor(_class.prototype, "prefix_number", [_dec9], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor11 = _applyDecoratedDescriptor(_class.prototype, "suffix_number", [_dec0], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor12 = _applyDecoratedDescriptor(_class.prototype, "date", [_dec1], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor13 = _applyDecoratedDescriptor(_class.prototype, "dati_invio_ts", [_dec10], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor14 = _applyDecoratedDescriptor(_class.prototype, "date_competence", [_dec11], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor15 = _applyDecoratedDescriptor(_class.prototype, "regime_fiscale", [_dec12], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor16 = _applyDecoratedDescriptor(_class.prototype, "fisica_giuridica", [_dec13], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor17 = _applyDecoratedDescriptor(_class.prototype, "society", [_dec14], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor18 = _applyDecoratedDescriptor(_class.prototype, "society_first_name", [_dec15], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor19 = _applyDecoratedDescriptor(_class.prototype, "society_last_name", [_dec16], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor20 = _applyDecoratedDescriptor(_class.prototype, "society_address", [_dec17], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor21 = _applyDecoratedDescriptor(_class.prototype, "society_piva_name", [_dec18], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor22 = _applyDecoratedDescriptor(_class.prototype, "society_piva", [_dec19], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor23 = _applyDecoratedDescriptor(_class.prototype, "society_cf", [_dec20], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor24 = _applyDecoratedDescriptor(_class.prototype, "rea", [_dec21], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor25 = _applyDecoratedDescriptor(_class.prototype, "imponibile", [_dec22], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor26 = _applyDecoratedDescriptor(_class.prototype, "total", [_dec23], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor27 = _applyDecoratedDescriptor(_class.prototype, "da_pagare", [_dec24], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor28 = _applyDecoratedDescriptor(_class.prototype, "pagato", [_dec25], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor29 = _applyDecoratedDescriptor(_class.prototype, "status", [_dec26], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor30 = _applyDecoratedDescriptor(_class.prototype, "status_sdi", [_dec27], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor31 = _applyDecoratedDescriptor(_class.prototype, "ts_codice", [_dec28], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor32 = _applyDecoratedDescriptor(_class.prototype, "ts_descrizione", [_dec29], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor33 = _applyDecoratedDescriptor(_class.prototype, "can_send_sdi", [_dec30], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor34 = _applyDecoratedDescriptor(_class.prototype, "lordo", [_dec31], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor35 = _applyDecoratedDescriptor(_class.prototype, "notes", [_dec32], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor36 = _applyDecoratedDescriptor(_class.prototype, "is_creditnote", [_dec33], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor37 = _applyDecoratedDescriptor(_class.prototype, "creditnote_invoicenumber", [_dec34], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor38 = _applyDecoratedDescriptor(_class.prototype, "creditnote_invoicedate", [_dec35], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor39 = _applyDecoratedDescriptor(_class.prototype, "thumbnail_url", [_dec36], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor40 = _applyDecoratedDescriptor(_class.prototype, "thumbnail_name", [_dec37], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor41 = _applyDecoratedDescriptor(_class.prototype, "thumbnail_etag", [_dec38], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor42 = _applyDecoratedDescriptor(_class.prototype, "thumbnail_type", [_dec39], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor43 = _applyDecoratedDescriptor(_class.prototype, "fixed_price_type", [_dec40], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor44 = _applyDecoratedDescriptor(_class.prototype, "fixed_price", [_dec41], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor45 = _applyDecoratedDescriptor(_class.prototype, "discount", [_dec42], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor46 = _applyDecoratedDescriptor(_class.prototype, "discount_rate", [_dec43], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor47 = _applyDecoratedDescriptor(_class.prototype, "discount_type", [_dec44], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor48 = _applyDecoratedDescriptor(_class.prototype, "bollo_cliente", [_dec45], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor49 = _applyDecoratedDescriptor(_class.prototype, "bollo_virtuale", [_dec46], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor50 = _applyDecoratedDescriptor(_class.prototype, "bollo", [_dec47], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor51 = _applyDecoratedDescriptor(_class.prototype, "rivalsa", [_dec48], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor52 = _applyDecoratedDescriptor(_class.prototype, "causale", [_dec49], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor53 = _applyDecoratedDescriptor(_class.prototype, "ditta", [_dec50], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor54 = _applyDecoratedDescriptor(_class.prototype, "mezzo", [_dec51], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor55 = _applyDecoratedDescriptor(_class.prototype, "data_consegna", [_dec52], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor56 = _applyDecoratedDescriptor(_class.prototype, "peso", [_dec53], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor57 = _applyDecoratedDescriptor(_class.prototype, "colli", [_dec54], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor58 = _applyDecoratedDescriptor(_class.prototype, "invoicegroups", [_dec55], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor59 = _applyDecoratedDescriptor(_class.prototype, "invoiceproducts", [_dec56], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor60 = _applyDecoratedDescriptor(_class.prototype, "invoicetaxes", [_dec57], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor61 = _applyDecoratedDescriptor(_class.prototype, "invoicemailsends", [_dec58], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor62 = _applyDecoratedDescriptor(_class.prototype, "files", [_dec59], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor63 = _applyDecoratedDescriptor(_class.prototype, "contact_fisica_giuridica", [_dec60], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor64 = _applyDecoratedDescriptor(_class.prototype, "contact_name", [_dec61], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor65 = _applyDecoratedDescriptor(_class.prototype, "contact_address", [_dec62], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor66 = _applyDecoratedDescriptor(_class.prototype, "contact_piva", [_dec63], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor67 = _applyDecoratedDescriptor(_class.prototype, "contact_cf", [_dec64], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor68 = _applyDecoratedDescriptor(_class.prototype, "contact_first_name", [_dec65], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor69 = _applyDecoratedDescriptor(_class.prototype, "contact_last_name", [_dec66], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor70 = _applyDecoratedDescriptor(_class.prototype, "contact_ente_pa", [_dec67], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor71 = _applyDecoratedDescriptor(_class.prototype, "custom_fields", [_dec68], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "sorted_custom_fields", [cached], Object.getOwnPropertyDescriptor(_class.prototype, "sorted_custom_fields"), _class.prototype), _descriptor72 = _applyDecoratedDescriptor(_class.prototype, "contacts", [_dec69], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor73 = _applyDecoratedDescriptor(_class.prototype, "products", [_dec70], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor74 = _applyDecoratedDescriptor(_class.prototype, "projects", [_dec71], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor75 = _applyDecoratedDescriptor(_class.prototype, "events", [_dec72], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor76 = _applyDecoratedDescriptor(_class.prototype, "workhours", [_dec73], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor77 = _applyDecoratedDescriptor(_class.prototype, "related_invoices", [_dec74], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor78 = _applyDecoratedDescriptor(_class.prototype, "expenses", [_dec75], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor79 = _applyDecoratedDescriptor(_class.prototype, "user", [_dec76], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor80 = _applyDecoratedDescriptor(_class.prototype, "contact", [_dec77], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor81 = _applyDecoratedDescriptor(_class.prototype, "payments", [_dec78], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor82 = _applyDecoratedDescriptor(_class.prototype, "invoices_notifiche_sdis", [_dec79], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor83 = _applyDecoratedDescriptor(_class.prototype, "expire_dates", [_dec80], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor84 = _applyDecoratedDescriptor(_class.prototype, "invoice_style", [_dec81], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor85 = _applyDecoratedDescriptor(_class.prototype, "pec_destinatario", [_dec82], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor86 = _applyDecoratedDescriptor(_class.prototype, "codice_destinatario", [_dec83], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor87 = _applyDecoratedDescriptor(_class.prototype, "pec_mittente", [_dec84], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor88 = _applyDecoratedDescriptor(_class.prototype, "assurance_id", [_dec85], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor89 = _applyDecoratedDescriptor(_class.prototype, "assurance_name", [_dec86], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor90 = _applyDecoratedDescriptor(_class.prototype, "quota_assistito", [_dec87], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor91 = _applyDecoratedDescriptor(_class.prototype, "quota_assicurazione", [_dec88], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor92 = _applyDecoratedDescriptor(_class.prototype, "pagato_assistito", [_dec89], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor93 = _applyDecoratedDescriptor(_class.prototype, "pagato_assicurazione", [_dec90], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor94 = _applyDecoratedDescriptor(_class.prototype, "bank_name", [_dec91], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor95 = _applyDecoratedDescriptor(_class.prototype, "bank_iban", [_dec92], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor96 = _applyDecoratedDescriptor(_class.prototype, "bank_bic", [_dec93], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor97 = _applyDecoratedDescriptor(_class.prototype, "sdi_field", [_dec94], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor98 = _applyDecoratedDescriptor(_class.prototype, "paid_all", [_dec95], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor99 = _applyDecoratedDescriptor(_class.prototype, "ts_send", [_dec96], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor100 = _applyDecoratedDescriptor(_class.prototype, "ts_enable", [_dec97], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor101 = _applyDecoratedDescriptor(_class.prototype, "esigibilita_iva", [_dec98], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor102 = _applyDecoratedDescriptor(_class.prototype, "valuta", [_dec99], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor103 = _applyDecoratedDescriptor(_class.prototype, "tasso_cambio", [_dec100], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor104 = _applyDecoratedDescriptor(_class.prototype, "data_option1", [_dec101], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor105 = _applyDecoratedDescriptor(_class.prototype, "data_option2", [_dec102], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor106 = _applyDecoratedDescriptor(_class.prototype, "boolean_option1", [_dec103], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor107 = _applyDecoratedDescriptor(_class.prototype, "total_files_number", [_dec104], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor108 = _applyDecoratedDescriptor(_class.prototype, "total_payments", [_dec105], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor109 = _applyDecoratedDescriptor(_class.prototype, "total_payments_number", [_dec106], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor110 = _applyDecoratedDescriptor(_class.prototype, "total_contacts_number", [_dec107], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor111 = _applyDecoratedDescriptor(_class.prototype, "total_products_number", [_dec108], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor112 = _applyDecoratedDescriptor(_class.prototype, "total_projects_number", [_dec109], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor113 = _applyDecoratedDescriptor(_class.prototype, "total_events_number", [_dec110], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor114 = _applyDecoratedDescriptor(_class.prototype, "total_invoices_number", [_dec111], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor115 = _applyDecoratedDescriptor(_class.prototype, "total_estimates_number", [_dec112], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor116 = _applyDecoratedDescriptor(_class.prototype, "total_ddts_number", [_dec113], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor117 = _applyDecoratedDescriptor(_class.prototype, "total_orders_number", [_dec114], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor118 = _applyDecoratedDescriptor(_class.prototype, "total_contracts_number", [_dec115], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor119 = _applyDecoratedDescriptor(_class.prototype, "current_users", [_dec116], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor120 = _applyDecoratedDescriptor(_class.prototype, "my_dirty", [_dec117], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class);

export { InvoiceModel as default };
//# sourceMappingURL=invoice.js.map
